const actions = {

    async LINK_BUSINESS({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'portmone/link',
                method:'POST',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },
    async UNLINK_BUSINESS({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'portmone/link',
                method:'DELETE',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },
    async GET_PORTMONE_CHECKOUT_URL({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'portmone/invoice',
                method:'POST',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );

    },

}

export default {
    namespaced:true,
    actions,
}